export const projectData = [
    {
        id: 1,
        title: "Social Soccer",
        link: "https://socialsoccer.gertobin.dev",
        image: "https://res.cloudinary.com/dyg53cwvw/image/upload/v1770063780/Screenshot_from_2026-02-02_20-21-59_okkjlq.webp",
        description:
            "A geospatial discovery app for local football matches. Built with Python and PostGIS, it implements proximity-based queries to calculate distances and filter games within a specific radius, providing real-time location-based results.",
    },
    {
        id: 2,
        title: "Paintball Kerry",
        link: "https://www.paintballkerry.com/",
        image: "https://res.cloudinary.com/dyg53cwvw/image/upload/v1672923559/website%20images/paintballkerry_1_shnrb7.webp",
        description:
            "A website for a local business, designed to provide key information to customers and provide a way of contacting them, Built on Django with Bootstrap. ",
    },
    {
        id: 3,
        title: "Guerin Photography",
        link: "https://guerinphotography.ie",
        image: "https://res.cloudinary.com/dyg53cwvw/image/upload/v1770032743/Screenshot_from_2026-02-02_11-43-00_zgqhjh.webp",
        description:
            "A website for a local photographer. Implemented in Sveltekit, designed for speed and visuals. Allows for image uploads and portfolio creation for the user with auto image optimisation using Sharp.",
    },
    {
        id: 4,
        title: "Tralee Orthotics",
        link: "https://traleeorthotics.ie",
        image: "https://res.cloudinary.com/dyg53cwvw/image/upload/v1770032743/Screenshot_from_2026-02-02_11-41-58_rg44z6.webp",
        description:
            "A website for a local orthotics company. Built in Sveltekit with Sanity.io as a CMS for managing the inventory.",
    },
];
